import React from 'react';
//mui
import { Box, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { makeStyles } from '@mui/styles';
import { getNumberComma } from '../../../utils/numberUtils';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

const OrderSheetDetails = ({ costs }) => {
  const classes = useStyles();

  if (!costs && costs?.length === 0) {
    return null;
  }

  return (
    <Box sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        size="small"
        className={classes.table}
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>제품명</TableCell>
              <TableCell>상세내역</TableCell>
              <TableCell>수량</TableCell>
              <TableCell>매입단가</TableCell>
              <TableCell>매입금액</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {costs &&
              costs.map((cost, index) => (
                <TableRow key={index}>
                  <TableCell>{costs.length - index}</TableCell>
                  <TableCell>{cost.productNm}</TableCell>
                  <TableCell>
                    <Typography
                      sx={{ whiteSpace: 'pre-line' }}
                      variant="body2"
                      component="div"
                    >
                      {cost?.productDesc}
                    </Typography>
                  </TableCell>
                  <TableCell>{cost.expCnt}</TableCell>
                  <TableCell>{getNumberComma(cost.priceVal)}</TableCell>
                  <TableCell>{getNumberComma(cost.buyVal)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OrderSheetDetails;
